<template>
  <div :class="$pgCTStyle.container">
    <div :class="$pgCTStyle.headerContainer">
      <!-- <div v-if="showAllGroupsCTA" :class="$style.titleEmptyContainer"></div> -->
      <div :class="$pgCTStyle.title">{{ finalTitle }}</div>
      <div v-if="showAllGroupsCTA" :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          :text="$t('all-groups')"
          :clickFunction="showAllGroupsPrelimVotes"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
      </div>
    </div>
    <div :class="$pgCTStyle.bodyContainer">
      <div
        v-for="(item, index) in preliminaryVotes"
        :key="index"
        :class="[$style.voteContainer, item.primaryTextId ? '' : $style.noVoteContainer]"
      >
        <div :class="$style.voteTextContainer">
          <div :class="$style.voteUserName">{{ translate('anon') }}</div>

          <template v-if="item.primaryTextId">
            <div :class="$style.voteChoices">
              <div :class="$style.voteChoice" v-if="item.primaryTextId">
                <span :class="$style.voteChoiceLabel">
                  {{ translate('choice') }} 1:
                </span>
                Text {{ texts.find((text) => text.id == item.primaryTextId).label }}
              </div>

              <div :class="$style.voteChoice" v-if="item.secondaryTextId">
                <span :class="$style.voteChoiceLabel">
                  {{ translate('choice') }} 2:
                </span>
                Text {{ texts.find((text) => text.id == item.secondaryTextId).label }}
              </div>
            </div>

            <div v-if="item.voteReason" :class="$style.voteReason">
              <span :class="$style.voteReasonLabel">
                {{ translate('reason') }}:
              </span>
              {{ item.voteReason }}
            </div>
          </template>

          <template v-if="!item.primaryTextId">
            <div :class="$style.noVoteText">
              {{ translate('prelim-no-vote') }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import styles from "@/css/PrelimVotesDisplayBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";

const NOOP = () => {};
const device = useDeviceType();

export default {
  components: { PGHeaderActionButton },
  name: "PrelimVotesDisplayBox",

  props: {
    canOpenAllGroups: {
      type: Boolean,
      required: false,
      default: false,
    },
    preliminaryVotes: {
      type: Array,
      required: true,
    },
    texts: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    openAllGroupsPrelimVotes: {
      type: Function,
      required: false,
      default: NOOP,
    },
    isHost: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t: translate } = useI18n();

    const finalTitle = computed(() => {
      return props.title || translate("prelim-votes");
    });

    return {
      translate,
      finalTitle,
    };
  },

  computed: {
    $style() {
      return styles;
    },
    $pgCTStyle() {
      return playGameComponentsTemplateStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
    showAllGroupsCTA() {
      return this.openAllGroupsPrelimVotes !== NOOP && this.canOpenAllGroups;
    },
  },

  methods: {
    showAllGroupsPrelimVotes() {
      this.openAllGroupsPrelimVotes();
    },
  },
};
</script>

<style scoped></style>
